export default __webpack_public_path__ + "static/media/archfiendspact.b6d5cea9.png";